import { gameMainDrawer } from '../game/drawers/gameMainDrawer';
import { betBarStore } from '../store/betBarStore';
import { isMobile } from './isMobile';
import {
  MOBILE_BET_CONTAINER_START_POSITION_X,
  WEB_BET_CONTAINER_START_POSITION_X,
} from '../constants';
import { animationService } from '../services/animationService';

export const betButtonContainerXPositionHandler = (index) => {
  const { betButtonContainer, betAmountButtonsWidthWithMargin } = gameMainDrawer.betBar;
  const startPosition = isMobile()
    ? MOBILE_BET_CONTAINER_START_POSITION_X
    : WEB_BET_CONTAINER_START_POSITION_X;

  const minXPosition = isMobile()
    ? gameMainDrawer.betBar.mobileBetContainerEndPositionX
    : gameMainDrawer.betBar.webBetContainerEndPositionX;

  betBarStore.betButtonSprites.forEach((sprite) => {
    if (index === sprite.id) {
      const itemNumber = Math.ceil(sprite.x / betAmountButtonsWidthWithMargin);
      const shownBetButtonCount = 4;
      const betButtonSlideAnimationMoveXValue = 4 * betAmountButtonsWidthWithMargin;
      const min = startPosition - itemNumber * betAmountButtonsWidthWithMargin;
      const max = startPosition - (itemNumber - 3) * betAmountButtonsWidthWithMargin;
      if (betButtonContainer.x >= min && betButtonContainer.x <= max) {
        return;
      }
      switch (true) {
        case itemNumber < shownBetButtonCount:
          betButtonContainer.x = startPosition;
          gameMainDrawer.betBar.setActiveArrowRightButton();
          gameMainDrawer.betBar.setArrowLeftButtonDisabled();
          break;
        case itemNumber < 2 * shownBetButtonCount:
          animationService.animateWithGsap({
            container: betButtonContainer,
            x: startPosition + -1 * betButtonSlideAnimationMoveXValue,
            onComplete: () => {
              gameMainDrawer.betBar.setActiveStateArrowButtons();
            },
            duration: 0.4,
          });
          break;
        case itemNumber < 3 * shownBetButtonCount:
          animationService.animateWithGsap({
            container: betButtonContainer,
            x:
              startPosition + -2 * betButtonSlideAnimationMoveXValue < minXPosition
                ? minXPosition
                : startPosition + -2 * betButtonSlideAnimationMoveXValue,
            onComplete: () => {
              gameMainDrawer.betBar.setActiveStateArrowButtons();
            },
            duration: 0.4,
          });
          break;
        case itemNumber < 4 * shownBetButtonCount:
          animationService.animateWithGsap({
            container: betButtonContainer,
            x:
              startPosition + -3 * betButtonSlideAnimationMoveXValue < minXPosition
                ? minXPosition
                : startPosition + -3 * betButtonSlideAnimationMoveXValue,
            onComplete: () => {
              gameMainDrawer.betBar.setActiveStateArrowButtons();
            },
            duration: 0.4,
          });
          break;
        case itemNumber < 5 * shownBetButtonCount:
          animationService.animateWithGsap({
            container: betButtonContainer,
            x:
              startPosition + -4 * betButtonSlideAnimationMoveXValue < minXPosition
                ? minXPosition
                : startPosition + -4 * betButtonSlideAnimationMoveXValue,
            onComplete: () => {
              gameMainDrawer.betBar.setActiveStateArrowButtons();
            },
            duration: 0.4,
          });
          break;
        default:
          animationService.animateWithGsap({
            container: betButtonContainer,
            x:
              startPosition + -5 * betButtonSlideAnimationMoveXValue < minXPosition
                ? minXPosition
                : startPosition + -5 * betButtonSlideAnimationMoveXValue,
            onComplete: () => {
              gameMainDrawer.betBar.setActiveArrowLeftButton();
              gameMainDrawer.betBar.setArrowRightButtonDisabled();
            },
            duration: 0.4,
          });
          break;
      }
    }
  });
};
